import { AppBar, DialogActions, DialogContent, Toolbar, Typography } from "@material-ui/core";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React, { useEffect, useState } from "react";
import XAPPButton from "../Button/XAPPButton";
import ConfirmacaoApp from "../Confirmacao/ConfirmacaoApp";
import XAPPDialog from "../Dialog/XAPPDialog";
import CustomFieldDialog from "./CustomFieldDialog";

const md = new MobileDetect(window.navigator.userAgent);

const newCustomField = {
  "id": "",
  "label": "",
  "type": "text",
  "locked": false,
  "required": false,
  "disabled": false,
  "index": 0,
};

const CustomFieldsEditable = (props) => {

  const { onClose, open = false, data, save, TIPOS_CAMPO } = props;
  const [form, setForm] = useState(null);
  const [dialogItem, setDialogItem] = useState(null);

  useEffect(() => {
    if (open && _.isNull(form)) {
      setForm(!_.isNull(data) ? data : { "campos": [], "grupos": [] });
    }
    if (!open && !_.isNull(form)) {
      setForm(null);
    }
  }, [open]);

  function addToForm(_AType, _AValue) {
    let ALista = [];
    if (!_.isUndefined(form[_AType]) && !_.isNull(form[_AType])) {
      ALista = ALista.concat(_.filter(form[_AType], x => x.id !== _AValue.id));
    }
    ALista.push(_AValue);
    setForm(_.set({ ...form }, _AType, ALista));
    setDialogItem(null);
  }

  return (
    <React.Fragment>
      <XAPPDialog
        id="CustomFieldsEdit"
        open={open}
        onClose={() => onClose()}
        fullWidth
        fullScreen={md.mobile() !== null}
        maxWidth="md"
      >
        <AppBar position="static" elevation={1}>
          <Toolbar className="flex w-full min-h-0">
            <Typography variant="subtitle1 text-white">
              {"Editar campos personalizados"}
            </Typography>
            <div className="flex-1" />
            <XAPPButton
              type="icon"
              icon={"close"}
              iconProps={"text-20 text-white"}
              className="p-6"
              onClick={() => onClose()}
            />
          </Toolbar>
        </AppBar>
        <div className="flex w-full justify-end border-b-1 mb-4 px-12">
          <XAPPButton
            className=""
            type="icon"
            tooltip={{ title: "Adicionar grupo", placement: "top" }}
            icon={"add"}
            onClick={() => setDialogItem({ "index": 0, "disabled": false, "tipo": "grupo", "id": new Date().getTime() })}
          />
        </div>
        <DialogContent className="" classes={{ root: "p-16" }}>
          {!_.isNull(form) && !_.isUndefined(form.grupos) && _.filter(form.grupos, { "disabled": false }).length > 0 ?
            _.orderBy(_.filter(form.grupos, { "disabled": false }), "index", "asc").map(grupo => (
              <div className={"border-1 rounded-6 mb-12"} key={grupo.id}>
                <div className="flex w-full border-b-1 mb-4 items-center">
                  <XAPPButton
                    className=""
                    type="icon"
                    noHover={true}
                    icon={"drag_drop"}
                    onClick={() => { }}
                  />
                  <Typography>{grupo.name} </Typography>
                  <div className="flex-1" />
                  <XAPPButton
                    className=""
                    type="icon"
                    tooltip={{ title: "Adicionar campo", placement: "top" }}
                    icon={"add"}
                    onClick={() => setDialogItem({ ...newCustomField, "tipo": "campo", "grupo": grupo.id, "id": new Date().getTime() })}
                  />
                  <XAPPButton
                    className=""
                    type="icon"
                    tooltip={{ title: "Editar grupo", placement: "top" }}
                    icon={"edit"}
                    onClick={() => setDialogItem({ ...grupo, "tipo": "grupo" })}
                  />
                  {_.filter(form.campos, { "grupo": grupo.id }).length > 0 ?
                    <ConfirmacaoApp
                      id={"DeleteGroup_" + grupo.id}
                      className=""
                      color=""
                      type="icon"
                      tooltip={{ title: "Remover grupo", placement: "top" }}
                      icon={"delete"}
                      mensagem={"Ao excluir este grupo todos os seus campos ficaram inacessíveis, confirma?"}
                      onConfirmation={() => addToForm("grupos", { ...grupo, "disabled": true })}
                    />
                    :
                    <XAPPButton
                      className=""
                      type="icon"
                      tooltip={{ title: "Remover grupo", placement: "top" }}
                      icon={"delete"}
                      onClick={() => addToForm("grupos", { ...grupo, "disabled": true })}
                    />
                  }
                </div>
                <div className="flex flex-col gap-8 p-12">
                  {!_.isUndefined(form.campos) && _.filter(form.campos, { "grupo": grupo.id }).length > 0 ?
                    _.orderBy(_.filter(form.campos, { "grupo": grupo.id, "disabled": false }), "index", "asc").map(item => (
                      <EditableField
                        key={item.id}
                        item={item}
                        setDialogItem={setDialogItem}
                        addToForm={addToForm}
                        TIPOS_CAMPO={TIPOS_CAMPO}
                      />
                    ))
                    :
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                      <div className="max-w-512 text-center">
                        <Typography variant="" color="textSecondary" className="">
                          {"Não existem campos personalizados!"}
                        </Typography>
                      </div>
                    </div>
                  }
                </div>
              </div>
            ))
            :
            <div className="flex flex-col flex-1 items-center justify-center p-16">
              <div className="max-w-512 text-center">
                <Typography variant="" color="textSecondary" className="">
                  {"Não existem campos personalizados!"}
                </Typography>
              </div>
            </div>
          }
        </DialogContent>
        <AppBar position="static" elevation={3} color="textSecondary">
          <Toolbar className="flex w-full justify-end min-h-0">
            <DialogActions>
              <XAPPButton
                type="Button"
                className="bg-green hover:bg-green text-white mr-8"
                variant="contained"
                color="primary"
                onClick={() => {
                  save(form);
                  onClose();
                }}
                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                icon={"save"}
                label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
              />
            </DialogActions>
          </Toolbar>
        </AppBar>
      </XAPPDialog>
      <CustomFieldDialog
        open={dialogItem}
        onClose={() => setDialogItem(null)}
        save={addToForm}
        TIPOS_CAMPO={TIPOS_CAMPO}
        grupos={_.filter(form?.grupos, { "disabled": false })}
      />
    </React.Fragment>
  );
};


export default CustomFieldsEditable;


const EditableField = props => {
  return (
    <div className="w-full flex items-center border-1 rounded-6 xs:flex-wrap xs:justify-end">
      <XAPPButton
        className=""
        type="icon"
        noHover={true}
        icon={"drag_drop"}
        onClick={() => { }}
      />
      <Typography>{`${props.item.label} [ ${_.find(props.TIPOS_CAMPO, { "id": props.item.type }).label} ]`}</Typography>
      <div className="flex-1" />
      {!props.item.locked &&
        <XAPPButton
          className=""
          type="icon"
          tooltip={{ title: "Editar campo", placement: "top" }}
          icon={"edit"}
          onClick={() => props.setDialogItem({ ...props.item, "tipo": "campo" })}
        />
      }
      {!props.item.locked &&
        <XAPPButton
          className=""
          type="icon"
          tooltip={{ title: "Remover campo", placement: "top" }}
          icon={"delete"}
          onClick={() => props.addToForm("campos", { ...props.item, "disabled": true })}
        />
      }
    </div>
  );
};